import angular from 'angular'

const billChangeModule = angular
    .module('app.billChange', [])

export default billChangeModule.name
// 规格、单位input
billChangeModule.component('qryspecInput', {
    template: '<input type="text" name="" class="form-control" placeholder="{{$ctrl.title}}" ng-model="$ctrl.model" ng-blur="$ctrl.specChange()"/>',
    bindings: {
        model: '=',
        title: '@',
        // specChange: '&'
    },
    controller: ['billChangeService', 'logger', function (billChangeService, logger) {
        let len = 0
        this.specChange = function () {
            if (billChangeService.lengthForString(this.model) > len) {
                this.model = ''
                logger.logError(`${this.title}不能大于${len}个字节`)
            }
        }
        this.$onInit = function () {
            switch (this.title) {
            case '规格型号':
                len = 40
                break
            case '单位':
                len = 22
                break
            }
            // return str;
        }
    }],

})
// 数量input
billChangeModule.component('qryQuantity', {
    template: '<input type="text" name="" class="form-control" placeholder="数量" ng-model="$ctrl.model.quantity" ng-blur="$ctrl.quantityChange()"/>',
    bindings: {
        model: '=',
        obj: '=',
    },
    controller: ['billChangeService', 'logger', 'globalFn', function (billChangeService, logger, globalFn) {
        this.quantityChange = function () {
            const billLine = this.model
            const { obj } = this
            const _that = billChangeService
            // 截取数字
            if (!Object.prototype.toString.call(billLine) === '[object Object]') return
            billLine.quantity = globalFn.cutOutPnumber(billLine.quantity, 15)
            const _isTax = obj.isTax
            if (globalFn.isNullVal(billLine.quantity)) {
                billLine.quantity = ''
                return
            }
            if (!_that.isQuantity(billLine.quantity)) {
                billLine.quantity = ''
                logger.logError('数量整数部分不能大于12个数字，小数部分不能大于15个数字')
                return
            }

            function quantityChange9Fn(argPrice, argPrice2, argAmount, argAmount2, argType) {
                // if (isTax()) {
                if (_that.isPrice(billLine[argPrice])) {
                    const _argAmount = globalFn.Mul(billLine.quantity, billLine[argPrice])
                    // argAmount

                    if (_that.hasBalanced(obj.detail)) {
                        billLine.taxAmount = _that.taxCalculation(_argAmount - billLine.balance, billLine.taxRate, _isTax)
                    } else {
                        billLine.taxAmount = _that.taxCalculation(_argAmount, billLine.taxRate, _isTax)
                    }
                    // if(argPrice=="taxPrice")var _argAmount2 = globalFn.Sub(_argAmount, billLine.taxAmount);
                    // if(argPrice=="price") var _argAmount2 =globalFn.Add(_argAmount, billLine.taxAmount)
                    billLine[argAmount] = _that._toFixed(_argAmount, 2)
                    const _argAmount2 = globalFn[argType](_argAmount, billLine.taxAmount)
                    billLine[argAmount2] = _that._toFixed(_argAmount2, 2)
                    // billLine[argPrice] = globalFn.Div(_argAmount2, billLine.quantity)
                    billLine[argPrice2] = globalFn.cutOutPnumber(globalFn.Div(_argAmount2, billLine.quantity), 15)
                }

                if (_that.isAmount(billLine[argAmount]) && globalFn.isNullVal(billLine[argPrice])) {
                    billLine[argPrice] = globalFn.cutOutPnumber(globalFn.Div(billLine[argAmount], billLine.quantity), 15)
                    if (_that.hasBalanced(obj.detail)) {
                        billLine.taxAmount = _that.taxCalculation(billLine[argAmount] - billLine.balance, billLine.taxRate, _isTax)
                    } else {
                        billLine.taxAmount = _that.taxCalculation(billLine[argAmount], billLine.taxRate, _isTax)
                    }
                    const _argAmount2 = globalFn[argType](billLine[argAmount], billLine.taxAmount)
                    billLine[argAmount2] = _that._toFixed(_argAmount2, 2)
                    // billLine.price = globalFn.Div(_amount, billLine.quantity)
                    billLine[argPrice2] = globalFn.cutOutPnumber(globalFn.Div(_argAmount2, billLine.quantity), 15)
                }


                // }
            }
            if (_that.isTax(obj)) {
                quantityChange9Fn('taxPrice', 'price', 'adValoremTotal', 'amount', 'Sub')
            } else {
                quantityChange9Fn('price', 'taxPrice', 'amount', 'adValoremTotal', 'Add')
            }
            // let resObj = _that.calTotalAmtTotalTaxamt(obj);
            // obj.totalTaxamt = resObj.totalTaxamt
            // obj.totalAmt = resObj.totalAmt
            // obj.adValoremTotal = resObj.adValoremTotal
            // obj.adValoremTotalChinese = resObj.adValoremTotalChinese
        }
    }],
})
// 单价input
billChangeModule.component('qryPrice', {
    template: ' <input type="text" name="" class="form-control" placeholder="单价({{$ctrl.taxword}})"ng-model="$ctrl.model.price" ng-blur="$ctrl.priceChange()"/>',
    bindings: {
        model: '=',
        obj: '=',
        taxword: '@',
    },
    controller: ['billChangeService', 'logger', 'globalFn', function (billChangeService, logger, globalFn) {
        this.priceChange = function () {
            const _isTax = this.obj.isTax
            const billLine = this.model
            const _that = billChangeService
            const { obj } = this
            function priceChange9Fn(argPirce, argPirce2, argAmount, argAmount2, argType) {
                if (globalFn.isNullVal(billLine[argPirce])) {
                    billLine.price = ''
                    billLine.taxPrice = ''
                    return
                }
                billLine[argPirce] = globalFn.cutOutPnumber(billLine[argPirce], 15)
                if (!_that.isPrice(billLine[argPirce])) {
                    billLine.taxPrice = ''
                    billLine.price = ''
                    logger.logError('单价整数部分不能大于12个数字，小数部分不能大于15个数字')
                    return
                }
                if (_that.isQuantity(billLine.quantity)) {
                    const _argAmount = globalFn.Mul(billLine.quantity, billLine[argPirce])

                    if (_that.hasBalanced(obj.detail)) {
                        billLine.taxAmount = _that.taxCalculation(_argAmount - billLine.balance, billLine.taxRate, _isTax)
                    } else {
                        billLine.taxAmount = _that.taxCalculation(_argAmount, billLine.taxRate, _isTax)
                    }
                    billLine[argAmount] = _that._toFixed(_argAmount, 2)
                    const _argAmount2 = globalFn[argType](_argAmount, billLine.taxAmount)
                    billLine[argAmount2] = _that._toFixed(_argAmount2, 2)
                    // billLine.price = globalFn.Div(_argAmount2, billLine.quantity)
                    billLine[argPirce2] = globalFn.cutOutPnumber(globalFn.Div(_argAmount2, billLine.quantity), 15)
                }
                if (globalFn.isNullVal(billLine.quantity) && _that.isAmount(billLine[argAmount])) {
                    const _argAmount = billLine[argAmount]
                    // billLine.quantity = globalFn.Div(_adValoremTotal, billLine.taxPrice)
                    billLine.quantity = globalFn.cutOutPnumber(globalFn.Div(_argAmount, billLine[argPirce]), 15)
                    if (_that.hasBalanced(obj.detail)) {
                        billLine.taxAmount = _that.taxCalculation(_argAmount - billLine.balance, billLine.taxRate, _isTax)
                    } else {
                        billLine.taxAmount = _that.taxCalculation(_argAmount, billLine.taxRate, _isTax)
                    }
                    const _argAmount2 = globalFn[argType](_argAmount, billLine.taxAmount)
                    billLine[argAmount2] = _that._toFixed(_argAmount2, 2)
                    // billLine.price = globalFn.Div(_argAmount2, billLine.quantity)
                    billLine[argPirce2] = globalFn.cutOutPnumber(globalFn.Div(_argAmount2, billLine.quantity), 15)
                }
            }
            if (_that.isTax(obj)) {
                priceChange9Fn('taxPrice', 'price', 'adValoremTotal', 'amount', 'Sub')
            } else {
                priceChange9Fn('price', 'taxPrice', 'amount', 'adValoremTotal', 'Add')
            }
            // let resObj = _that.calTotalAmtTotalTaxamt(obj);
            // obj.totalTaxamt = resObj.totalTaxamt
            // obj.totalAmt = resObj.totalAmt
            // obj.adValoremTotal = resObj.adValoremTotal
            // obj.adValoremTotalChinese = resObj.adValoremTotalChinese
        }
    }],
})
// 金额input
billChangeModule.component('qryAmount', {
    template: ' <input type="text" name="" class="form-control" placeholder="金额({{$ctrl.taxword}})"ng-model="$ctrl.model.amount"ng-blur="$ctrl.amountChange()"/>',
    bindings: {
        model: '=',
        taxword: '@',
        obj: '=',
    },
    controller: ['billChangeService', 'logger', 'globalFn', function (billChangeService, logger, globalFn) {
        this.amountChange = function () {
            const _isTax = this.obj.isTax
            const billLine = this.model
            const { obj } = this
            const _that = billChangeService
            function amountChange9Fn(argPrice, argPrice2, argAmount, argAmount2, argType) {
                if (globalFn.isNullVal(billLine[argAmount])) {
                    billLine.amount = ''
                    billLine.adValoremTotal = ''
                    return
                }
                const _argAmount = globalFn.cutOutPnumber(billLine[argAmount], 2)
                if (!_that.isAmount(_argAmount)) {
                    billLine.adValoremTotal = ''
                    billLine.amount = ''
                    logger.logError('金额整数部分不能大于12个数字，小数部分不能大于2个数字')
                    return
                }
                billLine[argAmount] = _that._toFixed(_argAmount, 2)
                if (_that.hasBalanced(obj.detail)) {
                    billLine.taxAmount = _that.taxCalculation(_argAmount - billLine.balance, billLine.taxRate, _isTax)
                } else {
                    billLine.taxAmount = _that.taxCalculation(_argAmount, billLine.taxRate, _isTax)
                }
                const _argAmount2 = globalFn[argType](_argAmount, billLine.taxAmount)
                billLine[argAmount2] = _that._toFixed(_argAmount, 2)
                if (_that.isPrice(billLine[argPrice])) {
                    billLine.quantity = globalFn.cutOutPnumber(globalFn.Div(_argAmount, billLine[argPrice]), 15)
                    billLine.price = globalFn.cutOutPnumber(globalFn.Div(_argAmount2, billLine.quantity), 15)
                }
                if (_that.isQuantity(billLine.quantity) && globalFn.isNullVal(billLine[argPrice])) {
                    billLine[argPrice] = globalFn.cutOutPnumber(globalFn.Div(_argAmount, billLine.quantity), 15)
                    billLine[argPrice2] = globalFn.cutOutPnumber(globalFn.Div(_argAmount2, billLine.quantity), 15)
                }
            }
            if (_that.isTax(obj)) {
                amountChange9Fn('taxPrice', 'price', 'adValoremTotal', 'amount', 'Sub')
            } else {
                amountChange9Fn('price', 'taxPrice', 'amount', 'adValoremTotal', 'Add')
            }
            // let resObj = _that.calTotalAmtTotalTaxamt(obj);
            // obj.totalTaxamt = resObj.totalTaxamt
            // obj.totalAmt = resObj.totalAmt
            // obj.adValoremTotal = resObj.adValoremTotal
            // obj.adValoremTotalChinese = resObj.adValoremTotalChinese
        }
    }],
})
// 税率select
billChangeModule.component('qryTaxrate', {
    template: ' <select ng-model="$ctrl.model.taxRate" ng-options="m.taxRate as m.taxText for m in $ctrl.arr" class="form-control"ng-selected="m.taxRate==$ctrl.model.taxRate" ng-change="$ctrl.taxRateChange()" name="taxRate" style="{{$ctrl.css}}"></select>',
    bindings: {
        model: '=',
        obj: '=',
        arr: '<',
        css: '@',
    },
    controller: ['billChangeService', 'logger', 'globalFn', function (billChangeService, logger, globalFn) {
        this.taxRateChange = function () {
            const _isTax = this.obj.isTax
            const billLine = this.model
            const { obj } = this
            const _that = billChangeService
            if (obj.invoiceType != '12') {
                if (billLine.taxRate === '') {
                    billLine.amount = ''
                    billLine.adValoremTotal = ''
                    return
                }
                // 零税率标识
                if (billLine.taxRate === 0) {
                    billLine.zeroTax = '3'
                } else {
                    billLine.zeroTax = ''
                }
                function taxRateChange9Fn(argPrice, argAmount, argAmount2, argType) {
                    if (!_that.isAmount(billLine[argAmount])) {
                        billLine.adValoremTotal = ''
                        billLine.amount = ''
                        return
                    }
                    if (_that.hasBalanced(obj.detail)) {
                        billLine.taxAmount = _that.taxCalculation(billLine[argAmount] - billLine.balance, billLine.taxRate, _isTax)
                    } else {
                        billLine.taxAmount = _that.taxCalculation(billLine[argAmount], billLine.taxRate, _isTax)
                    }
                    const _argAmount2 = globalFn[argType](billLine[argAmount], billLine.taxAmount)
                    billLine[argAmount2] = _that._toFixed(_argAmount2, 2)
                    // 不含税单价
                    if (_that.isQuantity(billLine.quantity)) {
                        // billLine.price = globalFn.Div(_amount, billLine.quantity)
                        billLine[argPrice] = globalFn.cutOutPnumber(globalFn.Div(_argAmount2, billLine.quantity), 15)
                    }
                }
                if (_that.isTax(obj)) {
                    taxRateChange9Fn('price', 'adValoremTotal', 'amount', 'Sub')
                } else {
                    taxRateChange9Fn('taxPrice', 'amount', 'adValoremTotal', 'Add')
                }
            } else {
                obj.totalTaxamt = _that.taxCalculation(obj.totalAmt, obj.taxRate)
            }
            // let resObj = _that.calTotalAmtTotalTaxamt(obj);
            // obj.totalTaxamt = resObj.totalTaxamt
            // obj.totalAmt = resObj.totalAmt
            // obj.adValoremTotal = resObj.adValoremTotal
            // obj.adValoremTotalChinese = resObj.adValoremTotalChinese
        }
    }],
})
// //纳税人识别号
// billChangeModule.component('qryCredit', {
//     template: ` <input ng-class="{redBorder:redBorderList.saleCreditCode}" placeholder="请输入纳税人识别号" class="autoClassInput" ng-model="param.saleCreditCode"
//     ng-blur="taxNoChange()" ng-change="checkCodeTypeaheadSelect()" />`,
//     bindings: {

//     },
//     controller: function () {

//     }
// })
// 计算总价
billChangeModule.component('qryTotalamt', {
    template: ` 
    <span>{{$ctrl.totalAmtChange()}}</span>
    `,
    bindings: {
        model: '=',
    },
    controller: ['billChangeService', function (billChangeService) {
        this.totalAmtChange = function () {
            this.model.totalAmt = billChangeService.calTotalAmtTotalTaxamt(this.model).totalAmt
            return this.model.totalAmt || 0.00
        }
    }],
})
// 计算总税额
billChangeModule.component('qryTotaltax', {
    template: `
    <span style="{{$ctrl.css}}">{{$ctrl.totalTaxamtChange()}}</span>
    `,
    bindings: {
        model: '=',
        css: '@',
    },
    controller: ['billChangeService', function (billChangeService) {
        this.totalTaxamtChange = function () {
            this.model.totalTaxamt = billChangeService.calTotalAmtTotalTaxamt(this.model).totalTaxamt
            return this.model.totalTaxamt || 0.00
        }
    }],
})
// 计算税价合计小写(vt--valorem tax)
billChangeModule.component('valoremTaxNum', {
    template: '<div class="form-control">(小写)¥<span>{{$ctrl.adValoremTotalChange()}}</span></div>',
    bindings: {
        model: '=',
    },
    controller: ['billChangeService', function (billChangeService) {
        this.adValoremTotalChange = function () {
            this.model.adValoremTotal = billChangeService.calTotalAmtTotalTaxamt(this.model).adValoremTotal
            return this.model.adValoremTotal || 0.00
        }
    }],
})
// 计算税价合计大写
billChangeModule.component('valoremTaxChinese', {
    template: '<div class="form-control">(大写)¥<span>{{$ctrl.adValoremTotalChineseChange()}}</span></div>',
    bindings: {
        model: '=',
    },
    controller: ['billChangeService', function (billChangeService) {
        this.adValoremTotalChineseChange = function () {
            this.model.adValoremTotalChinese = billChangeService.calTotalAmtTotalTaxamt(this.model).adValoremTotalChinese
            return this.model.adValoremTotalChinese || '零元整'
        }
    }],
})
// 新增商品行
/**
 * model: param
 * len : 商品行最大行数
 * arr : 税率数组
 * zero :零税率数组,
 * modalName:弹窗名
 * modalCtrlName：弹窗controller名
 * detailName:detail字段名,
 * isRed :是否红字信息表
 */
billChangeModule.component('addProduct', {
    template: `<a class="btn btn-primary btn-xs jia" ng-click="$ctrl.operatedAdd()"> 
                <i class="iconfont icon-jiahangmoren1"></i>
             </a>`,
    bindings: {
        model: '=',
        len: '@',
        arr: '<',
        zero: '<',
        modalName: '@',
        modalCtrlName: '@',
        detailName: '@',
        isRed: '<',
    },
    controller: ['billChangeService', 'logger', '$uibModal',
        function ctrl(billChangeService, logger, $uibModal) {
            this.operatedAdd = function operatedAdd() {
                // 差额征税的商品明细只能开具一行！
                // 判断商品是否为null
                const _that = this
                const billLineArr = this.model[this.detailName]
                if (billLineArr == null || billLineArr == undefined) {
                    this.model[this.detailName] = []
                }
                let bll = billLineArr ? billLineArr.length : 0
                if (bll >= this.len) {
                    logger.logError(`商品行数最多不能超过${this.len}行！`)
                    return
                }
                // 开票申请单上的商品明细行不超过8行。超过8行自动勾选清单
                const goodsMaxCol = 8
                const obj = billChangeService.operatedAdd()
                obj.serialNo = ++bll
                if (bll > goodsMaxCol) {
                    if (_that.isRed || _that.model.invType === '0') {
                        logger.logError('商品明细行最多8行')
                        return
                    }
                    // 详情弹窗
                    this.model.limitNumber = this.len
                    const listModalData = this.model // 数据
                    listModalData.taxRateArr = this.arr // 税率
                    listModalData.zeroTaxArr = this.zero// 零税率数组

                    // this.callback && this.callback({ listModalData: listModalData })
                    const modalInstance = $uibModal.open({
                        templateUrl: _that.modalName,
                        controller: _that.modalCtrlName,
                        openedClass: 'mod-modal-haslist mod-modal mod-modal-lg',
                        backdrop: 'static',
                        resolve: {
                            items1() {
                                return listModalData
                            },
                        },
                    })
                    modalInstance.result.then((item) => {
                        if (item.waitDetailList.length > goodsMaxCol) {
                            item.isList = '1'
                        } else {
                            item.isList = '0'
                        }
                        this.model = $.extend(this.model, item)
                    }, () => {
                        console.log(`Modal dismissed at: ${new Date()}`)
                    })
                }
                this.model[this.detailName].push(obj)
            }
        }],
})
// 删除商品行
/**
 * model : param ,
 * arr : 选中的数组 selectedRows
 * detailName:detail字段名,
*/
billChangeModule.component('delProduct', {
    template: ` <a class="btn btn-primary btn-xs jia" ng-click="$ctrl.operatedMinus()">
                    <i class="iconfont icon-jianhangweixuanzhong"></i>
               </a>`,
    bindings: {
        model: '=',
        arr: '=',
        detailName: '@',
        onDelete: '&',
    },
    controller: ['billChangeService', 'sweetalert', 'logger', '$timeout',
        function ctrl(billChangeService, sweetalert, logger, $timeout) {
            this.operatedMinus = function operatedMinus() {
                const invoice = this.model
                const productList = this.model[this.detailName]
                let msg = ''
                let minusCallback
                const _that = this
                const selectedList = this.arr
                if (selectedList.length > 0) {
                    // 是否含有折扣
                    if (billChangeService.hasDisBalelectedArr(productList, 'selected')) {
                        msg = '选中商品行包含差额/折扣/折扣行，确定删除？'
                        minusCallback = function minusCallback1() {
                            for (let i = 0, l = selectedList.length; i < l; i++) {
                                for (let a = 0; a < productList.length; a++) {
                                    if (productList[a].serialNo == selectedList[i]) {
                                        // 判断是否折扣行
                                        if (productList[+a + 1] && productList[+a + 1].lineNature === '1') {
                                            productList.splice(a, 2)
                                        } else {
                                            if (productList[a].lineNature === '1') productList[a - 1].discountRate = 0
                                            // $scope.modaldata[_that.detailName][a - 1].discountRate = 0
                                            productList.splice(a, 1)
                                        }
                                        break
                                    }
                                }
                            }
                        }
                    } else {
                        msg = '确认删除这些商品吗?'
                        minusCallback = function minusCallback2() {
                            for (let i = 0, l = selectedList.length; i < l; i++) {
                                for (let a = 0; a < productList.length; a++) {
                                    if (productList[a].serialNo == selectedList[i]) {
                                        productList.splice(a, 1)
                                        break
                                    }
                                }
                            }
                        }
                    }
                    // 弹出确认框

                    sweetalert.swal({
                        title: '删除提醒',
                        text: msg,
                        // type: "warning",
                        showCancelButton: true,
                        confirmButtonColor: '#0096e7',
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        closeOnConfirm: true,
                        closeOnCancel: true,
                    }, (isConfirm) => {
                        if (isConfirm) {
                            $timeout(() => {
                                minusCallback()
                                _that.arr.splice(0)
                                productList.forEach((product, index) => {
                                    product.serialNo = index + 1
                                })
                                // 确定处理
                                let goodsMaxCol = 8
                                if (_that.model.isChineseSecurity == '1') {
                                    goodsMaxCol = 7
                                }
                                _that.model.isList = productList.length > goodsMaxCol ? '1' : '0'
                                _that.onDelete && _that.onDelete()
                            })
                        }
                    })
                } else {
                    logger.logError('请先选择商品')
                }
            }
        }],
})



// WEBPACK FOOTER //
// ./src/components/billChange/index.js